import { ProfileDataType } from "../types/ProfileDataType";
import { fetchCustomersByEmail } from "./customerAPI";
import { mapProfileData } from "../utils/formatProfileData";
import { AuthApiService } from "../service/authService";
import { api } from "./api";

export const fetchProfileData = async (
  forceTrigger?: boolean
): Promise<ProfileDataType | null> => {
  try {
    const idToken = await AuthApiService.fetchIdToken();

    if (!idToken) {
      console.error("ID Token not found. User might not be logged in.");
      return null;
    }

    const { userEmail } = await AuthApiService.getUserEmail(idToken);

    if (!userEmail) {
      console.error("User email not found in token.");
      return null;
    }

    const data = await fetchCustomersByEmail(
      { emailId: userEmail },
      forceTrigger
    );

    const profileData = mapProfileData(data);

    return profileData;
  } catch (error) {
    console.error("Error fetching profile data:", error);
    return null;
  }
};

// API function to get user profile details
export const getUserProfile = async () => {
  try {
    const organizationId = localStorage.getItem("organizationId");
    const userEmail = localStorage.getItem("userEmail");

    if (!userEmail) {
      throw new Error("User email not found in localStorage");
    }

    const response = await api.get(`/get-user/${userEmail}`, {
      params: {
        orgId: organizationId,
      },
      headers: {
        orgId: organizationId,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching user profile:", error);
    if (error?.response?.data) {
      console.error("API Error:", error.response.data);
    }
    throw error;
  }
};

// API function to save profile details
export const saveProfileDetails = async (profileData: {
  companyName: string;
  phoneNumber: string;
  cin?: string;
  pan: string;
  gstNumber?: string;
  gstStateCode?: string;
  legalSignatory: string;
  registeredAddress: string;
  factoryAddress?: string;
  isFactorySameAsRegistered: boolean;
  accountName: string;
  accountNumber: string;
  bankName: string;
  bankBranch?: string;
  ifscCode: string;
}) => {
  try {
    const organizationId = localStorage.getItem("organizationId");
    const response = await api.post("/save-profile-details", profileData, {
      headers: { orgId: organizationId },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error saving profile details:", error);
    if (error?.response?.data) {
      console.error("API Error:", error.response.data);
    }
    throw error;
  }
};
